var _Fire;
import cn from 'clsx';
import Fire from '@crehana/icons/outline/Fire';
import { usePlayroomRewardsTranslations } from "../../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RemainingStockTag = function RemainingStockTag(_ref) {
  var stockCount = _ref.stockCount,
    rewardEnabled = _ref.rewardEnabled,
    className = _ref.className,
    style = _ref.style;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(
    // Positioning
    'tw-absolute tw-left-0 tw-top-0 tw-m-2',
    // Display
    'tw-flex tw-items-center tw-rounded-0.8 tw-px-0.8 tw-py-0.4',
    // Background
    'tw-bg-alert-400',
    // Font
    'tw-font-caption tw-text-neutral-light-100', rewardEnabled && 'tw-z-1', className),
    style: style,
    children: [_Fire || (_Fire = /*#__PURE__*/_jsx(Fire, {
      ignoreColor: true,
      size: 16,
      className: "tw-fill-current tw-mr-0.4"
    })), t('PRS_AVAILABLE_STOCK', {
      interpolation: {
        count: stockCount
      }
    })]
  });
};
export default RemainingStockTag;